import React, { useState, useEffect, useRef } from 'react';

const CustomSelect = ({ name, value, onChange, options, placeholder = 'Seleccionar' }) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const selected = options.find(o => o.value === value);

    const handleSelect = (optValue) => {
        onChange({ target: { name, value: optValue } });
        setOpen(false);
    };

    return (
        <div className={`cs-wrapper${open ? ' cs-wrapper--open' : ''}`} ref={wrapperRef}>
            <button
                type="button"
                className="cs-trigger"
                onClick={() => setOpen(v => !v)}
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <span className={selected ? 'cs-trigger-label' : 'cs-trigger-placeholder'}>
                    {selected ? selected.label : placeholder}
                </span>
                <svg className="cs-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </button>

            {open && (
                <ul className="cs-dropdown" role="listbox">
                    {options.map(o => {
                        const isSelected = value === o.value;
                        return (
                            <li
                                key={o.value}
                                role="option"
                                aria-selected={isSelected}
                                className={`cs-option${isSelected ? ' cs-option--selected' : ''}`}
                                onMouseDown={() => handleSelect(o.value)}
                            >
                                <span className="cs-option-label">{o.label}</span>
                                {isSelected && (
                                    <svg className="cs-check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default CustomSelect;
